// read more
document.addEventListener('DOMContentLoaded', function () {
  // Get all the buttons with the class 'toggleButton'
  const buttons = document.querySelectorAll('.read-more-button');

  // Loop through each button
  buttons.forEach(function (button) {
    // Add click event listener to each button
    button.addEventListener('click', function () {
      // Find the corresponding hidden content
      const hiddenContent = this.parentElement.nextElementSibling;

      // Toggle the display of the hidden content
      if (hiddenContent.classList.contains('more-text')) {
        if (hiddenContent.style.display === 'none') {
          hiddenContent.style.display = 'block';
          this.textContent = 'Lees minder...';
        } else {
          hiddenContent.style.display = 'none';
          this.textContent = 'Lees meer...';
        }
      }
    });
  });
});
